// @core/api/endpoints/secret/list_database_roles.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDatabaseRolesResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * List database roles
 * Returns all database roles in the engine.
 */
export async function ListDatabaseRoles(
  engine_id: string,
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListDatabaseRolesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/database/roles`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.get<ListDatabaseRolesResponse>(requestPath, { ...requestOptions, params });
}
